<template>
  <div class="extra-chips-component">
    <div class="column is-8 is-offset-2">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Quantos números de telefone você vai conectar no Pedbot?
          </p>
        </div>
      </div>
      <div class="choose-partners">
        <div class="columns mt-4">
          <div class="column is-full is-flex is-justify-content-center is-align-content-center">
            <div class="select is-large is-primary is-one-quarter">
              <select class="has-text-centered" v-model="extraChips.quantity">
                <option disabled selected>Selecionar</option>
                <option :value="number+1" v-for="(number) in chipsQuantity" :key="number">
                  {{ number+1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="columns mt-6">
          <div class="column is-full">
            <p class="is-size-4 has-text-centered has-text-grey-dark dm-sans">
              Cobramos um valor de R$ {{ formatPrice(extraChips.entity.price) }}/mês por conexão extra
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import extraChipsApi from '@/apis/extraChips'
import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'extra-chips',

  data() {
    return {
      extraChips: {
        quantity: null,
        entity: {}
      }
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  watch: {
    'formData.plan': {
      handler() {
        this.getChips()
      },
      deep: true
    },
    'extraChips.quantity': function (quantity) {
      this.setExtraChips(quantity)
    }
  },

  computed: {
    chipsQuantity() {
      return [...Array(10).keys()]
    }
  },

  methods: {
    cleanData() {
      this.extraChips.quantity = null
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    setExtraChips(quantity) {
      if (quantity === null) {
        return;
      }
      this.formData.extraServices.data = []
      const extraChip = JSON.parse(JSON.stringify(this.extraChips.entity))
      extraChip.quantity = quantity
      if (this.formData.messagePacket.data.mode === 2) {
        this.formData.messagePacket.data.quantity = quantity
        this.formData.messagePacket.data.price = ((parseFloat(this.formData.messagePacket.data.originalPrice) * quantity)).toString()
      }
      const appStore = useAppStore()
      appStore.showReviewNextButton = true
      if (quantity === 1) {
        extraChip.price = 0
        this.formData.extraChips.showStep = false
        this.formData.extraChips.data = {}
        return;
      } else {
        this.formData.extraChips.showStep = true
        extraChip.price = (parseFloat(this.extraChips.entity.price) * (quantity - 1))
      }
      extraChip.price = extraChip.price.toString()

      this.formData.extraChips.data = extraChip
    },
    async getChips() {
      if (this.formData.plan.data.id) {
        this.extraChips.entity = await extraChipsApi.get({
          plan_id: this.formData.plan.data.id
        })
      }
    }
  },

  mounted() {
    this.getChips()
  }

}

</script>
